import { get, remove, set } from 'lib/storage/isomorphicLocalStorage'

import whitelist from 'lib/payment/whitelist'
import { putCart } from 'api/cart'
import { getAllAmounts, getBaseSubtotalWithoutExtras } from 'selectors/cart/cartAmountSelectors'
import { slimifyGeo } from 'lib/geo/geoUtils'
import { getBedbankItems, getHotelItems } from 'storage/cartItem'

// When changing the structure of local storage item, increment the version of
// the key so that errors are not created in users' browsers.
const KEY = 'cartV48'
// Update the old as well as we'll use this to remove the old cart
const OLDKEY = 'cartV47'
try {
  remove(OLDKEY)
} catch (e) {
  // nothing
}

const storedCartProperties: Array<keyof App.CartState> = [
  'currencyCode',
  'items',
  'bedbank',
  'order',
  'bookDatesOnly',
  'isChangeDates',
  'isChangePackage',
  'insurance',
  'flight',
  'accommodation',
  'giftCard',
  'experiences',
  'isGift',
  'gift',
  'transactionKey',
]

export function setCart(cart: App.CartState) {
  try {
    const toStoreProps = whitelist(cart, storedCartProperties)
    const hasAccommodation = !!cart.accommodation.offer
    return set(KEY, {
      ...toStoreProps,
      accommodation: {
        ...toStoreProps.accommodation,
        // stop storing whole offer/package information in cart. Too large and
        // we want to ensure we always get latest version of these when we restore carts.
        // Have had times where users have old data and it's caused problems
        package: hasAccommodation ? {
          idSalesforceExternal: cart.accommodation.package?.id,
          uniqueKey: cart.accommodation.package?.uniqueKey,
        } : undefined,
        offer: hasAccommodation ? {
          id: cart.accommodation.offer?.id,
        } : undefined,
      },
    })
  } catch (e) {
    // Lots of errors are seen by IE/Edge of local storage running
    // out of space. Don't let trying to set the cart stop the page from working
    // just means they don't have a saved cart but they can continue
    // with the transaction
  }
}

export function getCart() {
  return get(KEY) as Partial<App.CartState> || {}
}

export function setInCartService(
  state: App.State,
  utmParams: { [param: string]: any },
) {
  const transactionKey = state.cart.transactionKey
  const geo = state.geo
  const subTotal = getBaseSubtotalWithoutExtras(state)
  const amounts = getAllAmounts(state)
  const totalWithFee = subTotal + amounts.propertyFeesAmount

  const items = [
    ...getHotelItems(state),
    ...getBedbankItems(state),
  ]

  if (items.length > 0) {
    const cartData = {
      items,
      utm_params: utmParams,
      geo: slimifyGeo(geo),
      total: totalWithFee,
    }
    return putCart(transactionKey, cartData)
      .catch(err => err)
  }
}
